import * as React from 'react';
import { AwardsWrapper, RatingsSources } from '../../components/Awards';
import { useSelector } from 'react-redux';
import { getDeveloperRatings } from '../../selectors/developerV2';
import { RatingCard, MedalsCard } from '../../components/AwardCard';
import { trackShowRatingsBlock } from './tracking';

export const Ratings = () => {
  const ratings = useSelector(getDeveloperRatings);

  if (!ratings) {
    return null;
  }

  return (
    <AwardsWrapper
      id="ratings"
      title="Позиции в рейтингах"
      sourceTooltip={<RatingsSources source={ratings.source} />}
      sourceLabel={ratings.text}
      onShow={trackShowRatingsBlock}
    >
      {ratings.ratings.map((rating, index) => (
        <RatingCard
          key={index}
          place={rating.value}
          placeLabel={rating.valueLabel}
          description={rating.description}
          icon={rating.iconUrl}
          help={rating.help}
        />
      ))}
      {ratings.medals && (
        <MedalsCard gold={ratings.medals.gold} silver={ratings.medals.silver} bronze={ratings.medals.bronze} />
      )}
    </AwardsWrapper>
  );
};
